export default __webpack_public_path__ + "static/media/ThriveLogoAxaHealth.c1c98816.png";